module.exports = __webpack_public_path__ + "img/greene-schools-logo.af20d9e3.jpg";